export const bigClothingBrands: string[] = [
  // Global sportswear
  'Nike','Adidas','Puma','Under Armour','Reebok','New Balance','Asics','Fila','The North Face','Columbia',
  // Luxury & designer
  'Gucci','Prada','Louis Vuitton','Chanel','Dior','Balenciaga','Versace','Saint Laurent','Givenchy','Fendi','Hermès','Burberry','Valentino','Bottega Veneta','Loewe',
  // Denim & casual
  "Levi's",'Diesel','G-Star RAW','Wrangler','Lee','Guess','Tommy Hilfiger','Calvin Klein','Ralph Lauren','Lacoste',
  // Fast fashion & high street
  'Zara','H&M','Uniqlo','Mango','Bershka','Pull&Bear','Stradivarius','Massimo Dutti','COS','Monki','Arket','Topshop','River Island','Primark',
  // Outdoor & streetwear
  'Patagonia','Arc’teryx','Salomon','Carhartt WIP','Stüssy','Supreme','A Bathing Ape','Off-White','Stone Island',
  // Footwear focus
  'Converse','Vans','Dr. Martens','Timberland','UGG','Birkenstock','Crocs','On','Hoka',
  // Luxury sneakers / contemporary
  'Alexander McQueen','Golden Goose','Common Projects','AMIRI','Lanvin'
];
